"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeSignVerify = exports.safeSign = void 0;
const ton_crypto_1 = require("ton-crypto");
function createSafeSignHash(cell) {
    return (0, ton_crypto_1.sha256_sync)(Buffer.concat([Buffer.from([0xff, 0xff]), Buffer.from('ton-safe-sign-magic'), cell.hash()]));
}
function safeSign(cell, secretKey) {
    return (0, ton_crypto_1.sign)(createSafeSignHash(cell), secretKey);
}
exports.safeSign = safeSign;
function safeSignVerify(cell, signature, publicKey) {
    return (0, ton_crypto_1.signVerify)(createSafeSignHash(cell), signature, publicKey);
}
exports.safeSignVerify = safeSignVerify;
